import { render } from "./UserNotificationView.vue?vue&type=template&id=ad127b1a&scoped=true"
import script from "./UserNotificationView.vue?vue&type=script&lang=js"
export * from "./UserNotificationView.vue?vue&type=script&lang=js"

import "./UserNotificationView.vue?vue&type=style&index=0&id=ad127b1a&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad127b1a"]])

export default __exports__